import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { INDRAAncillaryDiscardModalComponent } from '@ibe.components/shared/ancillary-discard-modal/ancillary-discard-modal.indra.component';
import { BookedTrip } from '@ibe/models';
import { Router } from '@angular/router';
import { ModalService } from '@ibe/services/ui';
import { isNullOrUndefined } from 'util';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as fromStore from '../../../store';

@Component({
	selector: 'app-flight-edit-options',
	templateUrl: './flight-edit-options.indra.component.html',
	styleUrls: ['./flight-edit-options.component.scss'],
	host: {
		class: 'app-flight-edit-options'
	}
})
export class INDRAFlightEditOptionsComponent implements OnInit {
	@Input()
	title: string;

	@Input()
	options = [];

	@Input()
	state: 'expanded' | 'collapsed' = 'collapsed';

	/*
	@Input()
	booked_trip: BookedTrip;
	*/
	@Output()
	addFeature = new EventEmitter();

	@Output()
	detailsFeature = new EventEmitter();

	bookedTrip$: Observable<BookedTrip>;
	booked_trip: BookedTrip;

	constructor(
		private store: Store<fromStore.State>,
		private router: Router,
		private modalService: ModalService) {

		this.bookedTrip$ = this.store.select(fromStore.getSelectedBookedTrip);
		this.bookedTrip$.subscribe(value => {
			if (value) {
				this.booked_trip = value;
			}
		});
	}

	/**
	 * Toggle the expanded/collapsed state;
	 */
	handleToggle() {
		if (this.state === 'expanded') {
			this.state = 'collapsed';
		} else {
			this.state = 'expanded';
		}
	}

	TAP_showLinks() {
		return this.options.length > 0 && !this.TAP_isGroupBooking();
	}


	TAP_isGroupBooking() {
		return this.booked_trip.is_group;
	}

	/**
	 * Handles click and redirect to router page
	 */
	TAP_linkClick(option) {
		const hasExtras = this.booked_trip.flights.some((flight) => {
			return flight.passengerInfo.some((pass) => {
				return pass.stops.some(info => {
					return !!(info.added_bags && info.added_bags.length) ||
						info.loungeEnabled || info.fastTrackEnabled || !isNullOrUndefined(info.boughtSeat) ||
						!isNullOrUndefined(info.specialMeals) || !!(info.sportsEquipment && info.sportsEquipment.length)
						|| !!(info.pets && info.pets.length) || !!(info.musicInstruments && info.musicInstruments.length);
				});
			});
		});

		if (hasExtras) {
			this.modalService.assignComponent(INDRAAncillaryDiscardModalComponent, option, this.booked_trip);
			this.modalService.open();
		} else {
			this.router.navigate([option.link], {
				queryParams: option.queryParams
			});
		}
	}

	TAP_isSSREC() {
		return this.booked_trip.status === 'ssrec';
	}

	ngOnInit() {
	}
}
